import styled from 'styled-components';

const AssignmentInfoTitle = styled.div`
  font-size: 18px;
  color: #333;
  margin: 5px 0 5% 0;
  font-weight: 400;
`;

export default AssignmentInfoTitle;
